import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import Welcome from "../components/content/Welcome";
import Perfil from "../components/content/Perfil";
import Aules from "../components/content/Aules";
import AulesId from "../components/aulaid/AulesId";
import Projectes from "../components/aulaid/content/Projectes";
import Mochila from "../components/content/Mochila";
import Cua from "../components/content/Cua";
import Dubtes from "../components/content/Dubtes";
import Javadex from "../components/content/Javadex";
import Javashop from "../components/content/Javashop";
import AdminManagement from "../components/content/AdminManagement";

const AppJutgeRoutes = () => {


    return (
        <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/mochila" element={<Mochila />} />
            <Route path="/javadex" element={<Javadex />} />
            <Route path="/projectes" element={<Projectes />} />
            <Route path="/aules" element={<Aules />} />
            <Route path="/cua" element={<Cua />} />
            <Route path="/dubte" element={<Dubtes />} />
            <Route path="/aules/:id_aula" element={<AulesId />} />
            <Route path="/aules/:id_aula/projectes/:id_projecte" element={<AulesId />} />
            <Route path="/aules/:id_aula/projectes/:id_projecte/exercicis/:id_tasca" element={<AulesId />} />
            <Route path="/javashop" element={<Javashop />} />
            <Route path="/admin" element={<AdminManagement />} />
            <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
    );
}

export default AppJutgeRoutes;